import { Preferences } from '@capacitor/preferences'
import { BundleInfo, CapacitorUpdater } from '@capgo/capacitor-updater'
import { SelectInputField, Typography } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { useSignal, useSignalEffect } from '@preact/signals-react'
import { reactBranch } from '../../../utils'
import { reactAppStage } from '../../../utils/reactAppStage'
import { switchReactBuild } from '../../appState/appStateListener'
import { NavigationView } from '../../layout/NavigationView'

export const EnvPage = () => {
    const currentBuild = useSignal<{
        bundle: BundleInfo
        native: string
    }>(null)

    useSignalEffect(() => {
        CapacitorUpdater.current().then((info) => {
            currentBuild.value = info
        })
    })

    return (
        <Box paddingTop={'10px'}>
            <NavigationView
                navigationBarTitle="Env Settings"
                backButtonAction={() => {
                    window.goBack()
                }}
                usePageTransition
            >
                <SelectInputField
                    fieldLabel="Stage (dev,test,demo)"
                    data={[
                        { displayName: 'dev', id: 'dev' },
                        { displayName: 'test', id: 'test' },
                        { displayName: 'demo', id: 'demo' },
                    ]}
                    defaultValue={reactAppStage()}
                    onChange={(value) => {
                        localStorage.clear()
                        Preferences.clear()
                        localStorage.setItem(
                            'REACT_APP_STAGE',
                            value.target.value as string
                        )
                    }}
                />
                <SelectInputField
                    fieldLabel="React branch (dev,test,demo)"
                    data={[
                        { displayName: 'dev', id: 'dev' },
                        { displayName: 'test', id: 'test' },
                        { displayName: 'demo', id: 'demo' },
                    ]}
                    defaultValue={reactBranch()}
                    onChange={(value) => {
                        switchReactBuild(value.target.value as string)
                    }}
                />

                <Typography>{'Current loaded build: '}</Typography>
                <pre>{JSON.stringify(currentBuild.value, null, 2)}</pre>
            </NavigationView>
        </Box>
    )
}
